import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import {Link} from 'react-router-dom'
const useStyles = makeStyles((theme) => ({
  
    paper: {
      padding: theme.spacing(2),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));

export default function CustomHeading(props) {
    const classes = useStyles();
    return(
      <Link to={props?.link}>
        <Paper className={classes.paper} style={{height:240,width:200,borderRadius:20,margin:'auto'}}>
            <img src={props?.image} height={'70%'} />
            <p style={{marginTop: 30}}>{props.title}</p>
        </Paper>
        </Link>
    )
}